"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SectionIndexScreen = require("./SectionIndexScreen");
Object.keys(_SectionIndexScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SectionIndexScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SectionIndexScreen[key];
    }
  });
});